var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStudentViewing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "student-on-piano-in-music-class-from-side-view",
    transform: "translate(-0.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(0.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M14.4,0V2.042h7.969V15.43c0,3.659-2.271,5.828-4.941,7.119a16.172,16.172,0,0,1-2.182.853l-.016.006c-.357.111-.712.21-1.061.3a.365.365,0,0,0-.052.014c-.35.086-.694.164-1.028.232-.8.162-1.541.27-2.165.34-1.13.129-1.874.138-1.874.138V40h27.78V0Z",
    transform: "translate(3.166)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M2.366,14.632.214,15.17l3.43,13.719H5.379l-2.226,4.9,1.346.612L7,28.888h3.672l1.091,2.5V26.672H5.376Z",
    transform: "translate(-0.214 5.595)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M13.211,17.141l.962,1.5a19.368,19.368,0,0,0,3.207-.908l-1.187-.1L12.809,12.3H7.925L4.982,26.894h4.96V19.063l.661-.006c.032,0,.86-.019,2.071-.176Z",
    transform: "translate(1.753 4.703)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M8.893,9.178a5.4,5.4,0,0,0-.094.538,4.361,4.361,0,0,0,0,.7,4.355,4.355,0,0,0,.09.492c.014.072.023.144.041.213.029.113.064.22.1.325A4.277,4.277,0,1,0,16.954,8.3l.686-1.129-1.577-.415.171-1.59-1.827.688L13.4,4.12l-1.463,1.8L10.582,4.583l-.429,1.944L8.114,6.039,9,7.653l-1.411.523Z",
    transform: "translate(2.811 1.575)",
    fill: "#0b4475"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudentViewing);
export default __webpack_public_path__ + "static/media/icon_student_viewing.ef90f7109ad5370b83beff20fd88ae6e.svg";
export { ForwardRef as ReactComponent };